import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface SwitchFieldProps {
  field: {
    name: string;
    label: string;
    disabled?: boolean;
    defaultValue?: boolean;
  };
}

export function SwitchField({ field }: SwitchFieldProps) {
  const { setValue, getValues } = useFormContext();

  const value = useWatch({
    name: field.name,
  });

   useEffect(() => {
    if (getValues(field.name) === undefined && field.defaultValue !== undefined) {
      setValue(field.name, field.defaultValue, {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false,
      });
    }
  }, []);

  return (
    <div className="flex items-center justify-between">
      <span className="text-gray-700">{field.label}</span>

      <button
        type="button"
        disabled={field.disabled}
        onClick={() => setValue(field.name, !value, { shouldDirty: true })}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full transition-colors
          ${value ? "bg-blue-600" : "bg-gray-300"}
          ${field.disabled ? "opacity-50 cursor-not-allowed" : ""}
        `}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white transition-transform
            ${value ? "translate-x-5" : "translate-x-1"}
          `}
        />
      </button>
    </div>
  );
}